import { z } from 'zod';
import { listResponse } from '../../utils/listResponse';
import { noteSchema, NotesListQuery, notesListQuerySchema } from '../models';

export const list = (query: NotesListQuery) => {
  return {
    endpoint: `/notes`,
    method: 'GET',
    responseSchema: listResponse(noteSchema),
    query: { ...query, includeTotal: true },
    querySchema: notesListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
